import React, { useState, useEffect } from "react";
import Filter from "../../components/Filter/Filter";
import ActionDialog from "../../components/Dialogs/ActionDialog";
import { FormDialog } from "../../components/FormDialog/FormDialog";
import { fetchAPIData, generateHiddenColumns, allPermissionOptions, createFilterOptions, createSortFieldOptions } from '../../Utils/Common';
import Table, { renderCellExpand } from '../../components/Table/Table';
import { usePersistentStorage } from "../../Utils/usePersistentStorage";

import Divider from '@mui/material/Divider';
import './system.scss';

const auditHistorySchema = require("../../json/auditHistorySchema.json").view;

const uiSchema = {
    "createdUserAgent": {
        "ui:options": {
            widget: "textarea",
            rows: 2
        }
    }
};


const SystemAuditHistoryTabPanel = ({ setNotify }) => {

    const [apiData, setApiData] = useState({});
    const [rowJsonData, setRowJsonData] = useState({});
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    const [reload, setReload] = useState(false);
    const [isLoading, setIsloading] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const [auditHistory, setAuditHistory] = usePersistentStorage("auditHistory", []);

    useEffect(() => {
        setApiData(auditHistory);
    }, []);

    const fieldData = [
        'eventType', 'objectId', 'objectType', 'objectFieldName', 'objectCompanyId', 'objectValueBefore', 'objectValueAfter', 'createdDate', 'createdUserId'
    ];

    const sortFieldData = [
        {
            field: 'eventType',
            label: 'Change Event'
        },
        {
            field: 'objectId',
            label: 'ID'
        },
        {
            field: 'objectType',
            label: 'Type'
        },
        {
            field: 'objectFieldName',
            label: 'Field'
        },
        {
            field: 'objectCompanyId',
            label: 'Company ID'
        },
        {
            field: 'objectValueBefore',
            label: 'Value Before'
        },
        {
            field: 'objectValueAfter',
            label: 'Value After'
        },
        {
            field: 'createdDate',
            label: 'Changed Date'
        },
        {
            field: 'createdUserId',
            label: 'Changed By'
        },
    ];

    const totalLabel = "Matching Audit History";

    const columns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            hideable: false,
            field: 'eventType',
            headerName: 'Change Event',
            minWidth: 300,
            maxWidth: 300,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable: false,
            field: 'objectId',
            headerName: 'ID',
            minWidth: 300,
            maxWidth: 300,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable: false,
            field: 'objectType',
            headerName: 'Type',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable: false,
            field: 'objectFieldName',
            headerName: 'Field',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable: false,
            field: 'objectCompanyId',
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            hideable: false,
            field: 'objectValueBefore',
            headerName: 'Value Before',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable: false,
            field: 'objectValueAfter',
            headerName: 'Value After',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable: false,
            field: 'createdDate',
            headerName: 'Changed Date',
            minWidth: 200,
            maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            hideable: false,
            field: 'createdUserId',
            headerName: 'Changed By',
            renderCell: renderCellExpand,
            minWidth: 400,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
        }
    ];

    const viewRowData = (param, event) => {
        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        setRowJsonData(JsonData);
        setMode('view');
        setOpen(true);
    };

    const fetchData = async (apiURL2, qparams) => {
        setIsloading(true);
        await fetchAPIData(apiURL2, qparams)
            .then((data) => {
                setApiData(data);
                setAuditHistory(data);
                // clear the reload false now that data is loaded
                setReload(false);
                setIsloading(false);
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load audit history data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                setReload(false);
                setIsloading(false);
            });

    }

    return (
        <>
            <div id="filterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
                <Filter permission={allPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL='/api/companies/histories?' fetchData={fetchData} useCompanyId={false} totalLabel={totalLabel} reload={reload} includeTotalDisplay={false} tabName={'auditHistoryTab'} />
            </div>


            <Divider />

            <div id="auditHistoryContainer">
                <div >
                    <Table data={apiData} columns={columns} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
                </div>
            </div>

            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                title="Audit History Information"
                defaultTab='JSON'
                propertiesTabContent={
                    <FormDialog
                        formId={'auditHistoryDialogId'}
                        readOnly={true}
                        schema={auditHistorySchema}
                        uiSchema={uiSchema}
                        formData={rowJsonData}
                    />
                }
                jsonDataName="Audit History"
                JSONTabContent={rowJsonData}
            />

        </>
    );
}

export default SystemAuditHistoryTabPanel;